import React, {useEffect, useState} from 'react';
import {Image, ImageStyle} from 'react-native';

interface ContainedImageProps {
  imageUrl: string | undefined;
  maxWidth?: string | number | undefined;
  alt?: string;
  style?: ImageStyle | undefined;
}

const ContainedImage: React.FC<ContainedImageProps> = props => {
  const {imageUrl, maxWidth, style = {}, alt} = props;
  const [aspectRatio, setAspectRatio] = useState<number>();
  const [currentWidth, setCurrentWidth] = useState<number>();

  useEffect(() => {
    Image.getSize(
      imageUrl || '',
      (width, height) => {
        setAspectRatio(height / width);
      },
      () => {
        setAspectRatio(0);
      }
    );
  }, [imageUrl]);

  return aspectRatio === 0 ? null : (
    <Image
      testID="contained-image"
      resizeMode="contain"
      source={{uri: imageUrl}}
      onLayout={({
        nativeEvent: {
          layout: {width},
        },
      }) => setCurrentWidth(width)}
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      style={{
        maxWidth,
        height:
          currentWidth && aspectRatio ? currentWidth * aspectRatio : undefined,
        ...style,
      }}
      alt={alt}
    />
  );
};

export default ContainedImage;
